/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioCategoryDto } from '../../models/portfolio-category-dto';
import { PortfolioCategoryUpdateDto } from '../../models/portfolio-category-update-dto';

export interface PortfolioCategoryAdminControllerUpdateV1$Params {
  id: string;
      body: PortfolioCategoryUpdateDto
}

export function portfolioCategoryAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: PortfolioCategoryAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioCategoryAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioCategoryDto>;
    })
  );
}

portfolioCategoryAdminControllerUpdateV1.PATH = '/api/v1/portfolios/categories/admin/{id}';
